"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ZInstagramLatestPostsResponse = exports.ZInstagramMedia = void 0;
const zod_1 = require("zod");
exports.ZInstagramMedia = zod_1.z.object({
    id: zod_1.z.string(),
    caption: zod_1.z.string().optional(),
    media_type: zod_1.z.enum(['IMAGE', 'VIDEO', 'CAROUSEL_ALBUM']).optional(),
    media_url: zod_1.z.string(),
    thumbnail_url: zod_1.z.string().optional(),
    permalink: zod_1.z.string(),
    timestamp: zod_1.z.string(),
});
exports.ZInstagramLatestPostsResponse = zod_1.z.object({
    latestPosts: zod_1.z.array(exports.ZInstagramMedia),
});
//# sourceMappingURL=models.js.map